import { http } from 'utils'
import { roles } from 'utils/auth'
import { SET_USER } from 'vx/mutations'
import { get } from 'lodash'

export default {
  namespaced: true,

  state: {
    user: {}
  },

  actions: {
    async authorize ({ commit }) {
      const response = await http.get('me')
      const role = get(response, 'data.data.role')

      if (role === roles.FIREFIGHTER) {
        throw new Error('Unauthorized access.')
      }

      commit(SET_USER, {
        ...response.data.data,
        ...{
          is_admin: role === roles.ADMIN,
          is_manager: role.includes('manager')
        }
      })

      return response
    }
  },

  mutations: {
    [SET_USER] (state, user) {
      state.user = user
    }
  }
}
